import { InjectionToken } from '@angular/core';

export const NB_SELECT_INJECTION_TOKEN = new InjectionToken('NB_SELECT_INJECTION_TOKEN');
